<template>
  <div v-if="broker != null && user != null">

    <PageHeader v-bind:label="isUserThisBroker ? 'Password' : broker.first_name + ' ' + broker.last_name + ' Password'"></PageHeader>
    
    <div class="my-8">
      <div class="flex flex-wrap" v-if="isUserThisBroker">
        <div class="w-full lg:w-1/2 pr-0 lg:pr-3">
          <InputPassword 
            label="Current password"
            propertyKey="currentPassword"
            v-bind:updateValue="updateValue"></InputPassword>

          <div v-if="errors.currentPassword != null" class="mt-2 text-red-600 text-sm">{{ errors.currentPassword }}</div>
        </div>
      </div>

      <div class="flex flex-wrap">
        <div class="w-full lg:w-1/2 pr-0 lg:pr-3">
          <div :class="{ 'label-line' : isUserThisBroker }">
            <div class="label-standard">New password</div>
          </div>

          <div class="form-line">
            <InputBrokerpadPassword 
              v-bind:value="newPassword"
              propertyKey="newPassword"
              v-bind:updatePassword="updateValue"></InputBrokerpadPassword>
          </div>

          <div v-if="errors.newPassword != null" class="mt-2 text-red-600 text-sm">{{ errors.newPassword }}</div>
        </div>
      </div>

      <div class="flex flex-wrap label-line">
        <div class="w-full lg:w-1/2 pr-0 lg:pr-3">
          <InputPassword 
            label="Please type your new password again"
            propertyKey="confirmNewPassword"
            v-bind:updateValue="updateValue"></InputPassword>

          <div v-if="errors.confirmNewPassword != null" class="mt-2 text-red-600 text-sm">{{ errors.confirmNewPassword }}</div>
        </div>
      </div>

      <div class="mt-12">
        <SubmitButton v-bind:onClick="submit" v-bind:loading="loading"></SubmitButton>
      </div>
    </div>
  </div>
</template>

<script>
  import InputPassword            from '@/shared/components/form/InputPassword'
  import InputBrokerpadPassword   from '@/shared/components/form/InputBrokerpadPassword'
  import { EventBus }             from '@/shared/event-bus';
  import PageHeader               from '@/shared/components/headers/PageHeader'
  import SubmitButton             from '@/shared/components/form/SubmitButton'

  function resetErrors() {
    return {
      currentPassword   : null,
      newPassword       : null,
      confirmNewPassword: null,
    }
  }

  export default {

    components: {
      InputPassword,
      InputBrokerpadPassword,
      PageHeader,
      SubmitButton
    },

    data () {
      return {
        loading           : false,
        broker            : null,
        user              : null,
        currentPassword   : null,
        newPassword       : null,
        confirmNewPassword: null,
        errors            : resetErrors()
      }
    },

    created() {
      // am I looking my own?
      if(this.$store.state[this.$store.state.view + 'Module'].broker.id == this.$route.params.brokerId) {
        this.user   = _.cloneDeep(this.$store.state.user)
        this.broker = _.cloneDeep(this.$store.state[this.$store.state.view + 'Module'].broker)
      }

      else if(this.isUserAdmin()) {
        this.apiGet({
          brokerId : this.$route.params.brokerId
        }, 'broker/detail', (broker) => {
          this.broker = broker

          this.apiGet({
            userId : broker.user_id
          }, 'user/detail', (user) => {
            this.hideLoader()
            this.user = user
          })
        })
      }
    },

    methods : {

      updateValue(params) {
        if(params != null && params.key != null && params.value != null) {
          this[params.key] = params.value
        }
      },

      submit() {

        this.errors = resetErrors()
        
        let valid = true

        if(this.isUserThisBroker && (this.currentPassword == null || this.currentPassword.length == 0)) {
          this.errors.currentPassword = "Please type your current password."
          valid = false;
        }

        if(this.newPassword == null || this.newPassword.length == 0) {
          this.errors.newPassword = "Please type a valid password."
          valid = false;
        }

        if(this.confirmNewPassword == null || this.confirmNewPassword.length == 0) {
          this.errors.confirmNewPassword = "Please type a valid confirm password."
          valid = false;
        }

        if(this.newPassword != this.confirmNewPassword) {
          this.errors.confirmNewPassword = "Password do not match."
          valid = false;
        }

        if(valid) {
          this.loading = true
          this.apiPost({
            userId         : this.user.id,
            currentPassword: this.currentPassword,
            newPassword    : this.newPassword,            
          }, 'user/password', (data) => {
            this.loading = false

            if(data.error != null) {
              this.errors.currentPassword = "Incorrect password"
            }

            else {
              EventBus.$emit('notification-event', {
                'type'   : 'success', 
                'message': 'Password saved successfully.'
              })            
            }        
          })
        }
      },
    },
  }
</script>